export default {
  dynamics: '{{change}} ift. forrige {{time_unit}}',
};
